import { legacyApiResourceUrl } from "@ploy-lib/core";
import { BaseCamelCasedResource } from "../resources/BaseResource";
class ProofOfDeliveryReleasedInformationResource extends BaseCamelCasedResource {
    pk() {
        return this.applicationNumber;
    }
}
ProofOfDeliveryReleasedInformationResource.urlRoot = legacyApiResourceUrl("ProofOfDelivery/IsProofOfDeliveryReleased");
export { ProofOfDeliveryReleasedInformationResource };
//# sourceMappingURL=ProofOfDeliveryReleasedResource.js.map